import { useAuth } from 'context/auth'
import AuthRoutes from './auth-routes'
import OnboardOrganisationRoutes from './onboard-organisation-routes'
import OrganisationRoutes from './organisation-routes'
import PublicRoutes from './public-routes'
import SetupRoutes from './setup-routes'

const Routes = () => {
  const { currentUser } = useAuth()
  const routes = PublicRoutes

  // PUBLIC - No user logged in
  if (!currentUser) {
    console.log('→ Auth routes (Login/Signup)')
    return routes.concat(AuthRoutes)
  }

  // ONBOARDING - No account yet. New self-serve signups go straight into the
  // setup wizard; its Welcome step captures the organisation name and creates
  // the account (POST /account), so there is no separate pre-wizard org page.
  // The legacy OnboardOrganisationRoutes now only serves old in-flight accounts
  // (branch below: account exists, no onboarding, onBoardingStep < 3).
  if (!currentUser.account) {
    console.log('→ Setup wizard (new account, Welcome captures org name)')
    return routes.concat(SetupRoutes)
  }

  // NEW SETUP WIZARD - account exists and the wizard is not yet complete.
  if (
    currentUser.account?.onboarding &&
    !currentUser.account.onboarding.completedAt
  ) {
    console.log('→ Setup wizard')
    return routes.concat(SetupRoutes)
  }

  // LEGACY ONBOARDING - existing accounts without account.onboarding that have
  // not finished the old 3-step flow stay on the legacy flow.
  if (!currentUser.account?.onboarding && currentUser.onBoardingStep < 3) {
    console.log('→ Legacy onboarding (onBoardingStep < 3)')
    return routes.concat(OnboardOrganisationRoutes)
  }

  // DASHBOARD - Onboarding complete (wizard finished, or legacy account at step >= 3)
  console.log('→ Dashboard')
  return routes.concat(OrganisationRoutes)
}

export default Routes
